import React from 'react';
import Tabs from '@mui/material/Tabs';
import {useParams} from 'react-router-dom';

import StakeTab from './StakeTab';
import './StakeTabsNavigation.scss';
import StakeHistory from "../StakeHistory/StakeHistory";
import StakePendingWithdrawals from "../StakePendingWithdrawals/StakePendingWithdrawals";
import {depositWithdrawalStakeStore} from "../../../services/deposit-withdrawal-stake/deposit-withdrawal-stake.store";

const StakeTabValue = {
    HISTORY: 'history',
    PENDING_WITHDRAWALS: 'pending-withdrawals',
}

const StakeTabsNavigation = () => {

    const {  tab: routeTab } = useParams();
    const currentTab = routeTab || StakeTabValue.HISTORY

    return (
        <div className="StakeTabsNavigation">
            <Tabs value={currentTab} TabIndicatorProps={{
                style: {
                    display: 'none'
                }
            }}>
                <StakeTab label="History" to={`/stake`} value={StakeTabValue.HISTORY} />
                <StakeTab label={`Pending Withdrawals${depositWithdrawalStakeStore.pendingWithdrawalsCount ? ' (' + depositWithdrawalStakeStore.pendingWithdrawalsCount + ')' : ''}`} to={`/stake/pending-withdrawals`} value={StakeTabValue.PENDING_WITHDRAWALS} />
            </Tabs>
            {currentTab === StakeTabValue.HISTORY && <StakeHistory />}
            {currentTab === StakeTabValue.PENDING_WITHDRAWALS && <StakePendingWithdrawals />}
        </div>
    );
};

export default StakeTabsNavigation;